import React from 'react';
import ToggleSwitch from './ToggleSwitch';
import CategorySelector from './CategorySelector';

const NotificationSettings = ({ schoolData, updateSchoolData }) => {
  // Handle toggle change
  const handleToggleChange = (section, key, value) => {
    // In a real application, you would update notification settings in the school data
    // For demo purposes, we'll just log the changes
    console.log(`Changed ${section}.${key} to ${value}`);
  };

  // Handle category selection
  const handleCategorySelect = (section, items) => {
    // In a real application, you would update notification categories in the school data
    // For demo purposes, we'll just log the changes
    console.log(`Updated ${section} categories:`, items);
  };

  // Example notification categories
  const academyCategories = ['Progress reports', 'Exam results'];
  const paymentCategories = ['Upcoming fees', 'Overdue fees'];
  const generalCategories = ['School events', 'Closures'];
  const emergencyCategories = ['Urgent safety messages'];

  return (
    <div className="space-y-10">
      {/* Email & SMS Notifications */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* Email Section */}
        <div>
          <h3 className="text-lg font-medium mb-2">Email</h3>
          <p className="text-sm text-gray-500 mb-6">Enable or disable email notifications for specific updates</p>
          
          <div className="space-y-6">
            <ToggleSwitch
              label="Report cards"
              initialState={true}
              onChange={(value) => handleToggleChange('email', 'reportCards', value)}
            />
            
            <ToggleSwitch
              label="Payment reminders"
              initialState={true}
              onChange={(value) => handleToggleChange('email', 'paymentReminders', value)}
            />
            
            <ToggleSwitch
              label="Attendance alerts"
              initialState={true}
              onChange={(value) => handleToggleChange('email', 'attendanceAlerts', value)}
            />
            
            <ToggleSwitch
              label="Emergency announcements"
              initialState={true}
              onChange={(value) => handleToggleChange('email', 'emergencyAnnouncements', value)}
            />
          </div>
        </div>
        
        {/* SMS Section */}
        <div>
          <h3 className="text-lg font-medium mb-2">SMS</h3>
          <p className="text-sm text-gray-500 mb-6">Enable or disable SMS notifications for specific updates</p>
          
          <div className="space-y-6">
            <ToggleSwitch
              label="Report cards"
              initialState={true}
              onChange={(value) => handleToggleChange('sms', 'reportCards', value)}
            />
            
            <ToggleSwitch
              label="Payment reminders"
              initialState={true}
              onChange={(value) => handleToggleChange('sms', 'paymentReminders', value)}
            />
            
            <ToggleSwitch
              label="Attendance alerts"
              initialState={true}
              onChange={(value) => handleToggleChange('sms', 'attendanceAlerts', value)}
            />
            
            <ToggleSwitch
              label="Emergency announcements"
              initialState={true}
              onChange={(value) => handleToggleChange('sms', 'emergencyAnnouncements', value)}
            />
          </div>
        </div>
      </div>
      
      {/* Push Notifications */}
      <div>
        <h3 className="text-lg font-medium mb-2">Push notification</h3>
        <p className="text-sm text-gray-500 mb-6">Enable or disable push notification for app users</p>
        
        <ToggleSwitch
          label="Enable push notifications"
          initialState={true}
          onChange={(value) => handleToggleChange('push', 'enabled', value)}
        />
      </div>
      
      {/* Message Categorization */}
      <div>
        <h3 className="text-lg font-medium mb-2">Message Categorization</h3>
        <p className="text-sm text-gray-500 mb-6">Categorize messages for easy streamlining</p>
        
        <div className="space-y-6">
          <CategorySelector
            label="Academy Updates"
            categories={academyCategories}
            initialSelected={['Progress reports', 'Exam results']}
            onSelectionChange={(items) => handleCategorySelect('academyUpdates', items)}
          />
          
          <CategorySelector
            label="Payment Reminders"
            categories={paymentCategories}
            initialSelected={['Upcoming fees', 'Overdue fees']}
            onSelectionChange={(items) => handleCategorySelect('paymentReminders', items)}
          />
          
          <CategorySelector
            label="General Announcements"
            categories={generalCategories}
            initialSelected={['School events', 'Closures']}
            onSelectionChange={(items) => handleCategorySelect('generalAnnouncements', items)}
          />
          
          <CategorySelector
            label="Emergency Alerts"
            categories={emergencyCategories}
            initialSelected={['Urgent safety messages']}
            onSelectionChange={(items) => handleCategorySelect('emergencyAlerts', items)}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;